import VenueList from "../../shared/components/AllVenues/VenueList";
import AnimatedCards from "../../shared/components/AnimatedCards/AnimatedCards";
import AnimatedItemsList from "../../shared/components/AnimatedScroll/AnimatedScrollImage";
import AnimatedScrollImage from "../../shared/components/AnimatedScrollImage/AnimatedScrollImage";
import BoxLink from "../../shared/components/BoxLink/BoxLinks";
import BrowseAllVacancies from "../../shared/components/BrowseAllVacancies/BrowseAllVacancies";
import Carousel from "../../shared/components/Carousel/Carousel";
import FAQAccordion from "../../shared/components/FAQAccordion/FAQAccordion";
import Hero from "../../shared/components/Hero/Hero";
import HeroMap from "../../shared/components/HeroMap/index";
import HoverImageBoxes from "../../shared/components/HoverImageBoxes/HoverImageBoxes";
import HoverRevealCard from "../../shared/components/HoverRevealCard/HoverRevealCard";
import Image from "../../shared/components/Image/Image";
import ImageSlideshow from "../../shared/components/ImageSlideshow/ImageSlideshow";
import ImageWithDescription from "../../shared/components/ImageWithDescription/ImageWithDescription";
import Instagram from "../../shared/components/InstagramFeed/Instagram";
import JobAlert from "../../shared/components/JobAlert/JobAlert";
import JobSummaryWithMap from "../../shared/components/JobSummaryWithMap/JobSummaryWithMap";
import KeyPointsBar from "../../shared/components/KeyPointsBar/KeyPointsBar";
import LatestJobs from "../../shared/components/LatestJobs/LatestJobs";
import MapSlideshow from "../../shared/components/MapSlideshow/MapSlideshow";
import MapStandalone from "../../shared/components/MapStandalone/MapStandalone";
import MapWithTextArea from "../../shared/components/MapWithTextArea/MapWithTextArea";
import PerksWithImages from "../../shared/components/PerksWithImages/PerksWithImages";
import ProfileCardGallery from "../../shared/components/ProfileCardGallery/ProfileCardGallery";
import RedirectButton from "../../shared/components/RedirectButton/RedirectButton";
import ReferAFriend from "../../shared/components/ReferAFriend/ReferAFriend";
import RelatedJobsGallery from "../../shared/components/RelatedJobsGallery/RelatedJobsGallery";
import RoleCards from "../../shared/components/RoleCards/RoleCards";
import SearchBox from "../../shared/components/SearchBox/SearchBox";
import SearchResults from "../../shared/components/SearchResults/SearchResults";
import SingleJob from "../../shared/components/SingleJob/SingleJob";
import TextWith from "../../shared/components/TextWith/TextWith";
import VenueDescription from "../../shared/components/VenueDescription/VenueDescription";
import Venues from "../../shared/components/Venues/Venues";
import VideoGalleryTabs from "../../shared/components/VideoGalleryTabs/VideoGalleryTabs";
import BlogPostList from "../BlogPostList/BlogPostList";
import Iframe from "../Iframe/Iframe";
import LatestBlogs from "../LatestBlogs/LatestBlogs";
// eslint-disable-next-line import/no-cycle
import Post from "../Post/Post";
import SingleJobHero from "../SingleJobHero/SingleJobHero";
import SingleVenueHero from "../SinglePlaceResults/SingleVenueHero";
import SingleVenueSearchResults from "../SinglePlaceResults/SingleVenueSearchResults";

const componentMap = {
  "blog.blog-post-list": {
    Component: BlogPostList,
    additionalProps: {},
  },
  "blog.latest-blogs": {
    Component: LatestBlogs,
    additionalProps: {},
  },
  "blog.post": {
    Component: Post,
    additionalProps: {},
  },
  "related-to.related-to": {
    Component: LatestJobs,
    additionalProps: {},
  },
  "reusable-components.all-venues": {
    Component: VenueList,
    additionalProps: {},
  },
  "reusable-components.animated-items-list": {
    Component: AnimatedItemsList,
    additionalProps: {},
  },
  "reusable-components.animated-card": {
    Component: AnimatedCards,
    additionalProps: {},
  },
  "reusable-components.animated-cards": {
    Component: AnimatedCards,
    additionalProps: {},
  },
  "reusable-components.animated-scroll-image": {
    Component: AnimatedScrollImage,
    additionalProps: {},
  },
  "reusable-components.carousel": {
    Component: Carousel,
    additionalProps: {},
  },
  "reusable-components.box-link-list": {
    Component: BoxLink,
    additionalProps: {},
  },
  "reusable-components.browse-all-vacancies": {
    Component: BrowseAllVacancies,
    additionalProps: {},
  },
  "reusable-components.faq-accordion": {
    Component: FAQAccordion,
    additionalProps: {},
  },
  "reusable-components.hero": {
    Component: Hero,
    additionalProps: {},
  },
  "reusable-components.i-frame": {
    Component: Iframe,
    additionalProps: { fullWidth: true },
  },
  "reusable-components.image-slideshow": {
    Component: ImageSlideshow,
    additionalProps: {},
  },
  "reusable-components.image": { Component: Image, additionalProps: {} },
  "reusable-components.image-with-description": {
    Component: ImageWithDescription,
    additionalProps: {},
  },
  "reusable-components.hover-image-boxes": {
    Component: HoverImageBoxes,
    additionalProps: {},
  },
  "reusable-components.hover-reveal-cards": {
    Component: HoverRevealCard,
    additionalProps: {},
  },
  "reusable-components.instagram-feed": {
    Component: Instagram,
    additionalProps: {},
  },
  "reusable-components.job-alert": {
    Component: JobAlert,
    additionalProps: {},
  },
  "reusable-components.job-summary-with-map": {
    Component: JobSummaryWithMap,
    additionalProps: {},
  },
  "reusable-components.hero-map": {
    Component: HeroMap,
    additionalProps: {},
  },
  "reusable-components.key-points-bar": {
    Component: KeyPointsBar,
    additionalProps: {},
  },
  "reusable-components.latest-jobs": {
    Component: LatestJobs,
    additionalProps: { viewAllButton: false },
  },
  "reusable-components.map": {
    Component: MapStandalone,
    additionalProps: { withMarkers: true },
  },
  "reusable-components.map-slideshow": {
    Component: MapSlideshow,
    additionalProps: {},
  },
  "reusable-components.map-with-text-area": {
    Component: MapWithTextArea,
    additionalProps: {},
  },
  "reusable-components.perks-with-images": {
    Component: PerksWithImages,
    additionalProps: {},
  },
  "reusable-components.profile-card-gallery": {
    Component: ProfileCardGallery,
    additionalProps: {},
  },
  "reusable-components.redirect-button": {
    Component: RedirectButton,
    additionalProps: { viewAllButton: false },
  },
  "reusable-components.refer-a-friend": {
    Component: ReferAFriend,
    additionalProps: {},
  },
  "reusable-components.related-jobs-gallery": {
    Component: RelatedJobsGallery,
    additionalProps: {},
  },
  "reusable-components.role-cards": {
    Component: RoleCards,
    additionalProps: {},
  },
  "reusable-components.search-box": {
    Component: SearchBox,
    additionalProps: {},
  },
  "reusable-components.search-results": {
    Component: SearchResults,
    additionalProps: {},
  },
  "reusable-components.single-job": {
    Component: SingleJob,
    additionalProps: {},
  },
  "reusable-components.single-job-hero": {
    Component: SingleJobHero,
    additionalProps: {},
  },
  "reusable-components.text-with": {
    Component: TextWith,
    additionalProps: {},
  },
  "reusable-components.venues": {
    Component: Venues,
    additionalProps: {},
  },
  "single-venue.single-venue-description": {
    Component: VenueDescription,
    additionalProps: {},
  },
  "single-venue.single-venue-hero": {
    Component: SingleVenueHero,
    additionalProps: {},
  },
  "single-venue.single-venue-search-results": {
    Component: SingleVenueSearchResults,
    additionalProps: {},
  },
  "reusable-components.video-gallery-tabs": {
    Component: VideoGalleryTabs,
    additionalProps: {},
  },
};

export default componentMap;
